<input #input type="text" class= "latch-form-control" [placeholder]="placeholder" [ngModel]="value"
  (ngModelChange)="writeValue($event)" [disabled]="disabled"/>
